<template>
  <SMSList
    client_name="DY"
    table_class="doomYogaTable"
    overlay_variant="doom-yoga-primary"
    select_filter_class="v-select-doomyoga"
    view_img_path="doom-yoga/view-icon-table.png"
    currency="€"
  />
</template>


<script>
import SMSList from "@/components/SMS/List.vue";

export default {
  name: "DoomYogaSMS",
  components: { SMSList },
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doom_yoga/admin/marketing/SMS.vue